"use client";

import { useMemo } from "react";
import { useTimePilotT } from "./useTimePilotT";

/** AG Grid `localeText` keys this app surfaces, mapped to `grid.*` catalog ids. */
const GRID_LOCALE_KEYS = [
  ["noRowsToShow", "grid.noRowsToShow"],
  ["loadingOoo", "grid.loading"],
  ["filterOoo", "grid.filter"],
  ["pinColumn", "grid.pinColumn"],
  ["pinLeft", "grid.pinLeft"],
  ["pinRight", "grid.pinRight"],
  ["noPin", "grid.noPin"],
  ["autosizeThiscolumn", "grid.autosizeThisColumn"],
  ["autosizeAllColumns", "grid.autosizeAllColumns"],
  ["resetColumns", "grid.resetColumns"],
  ["equals", "grid.equals"],
  ["notEqual", "grid.notEqual"],
  ["contains", "grid.contains"],
  ["notContains", "grid.notContains"],
  ["startsWith", "grid.startsWith"],
  ["endsWith", "grid.endsWith"],
  ["blank", "grid.blank"],
  ["notBlank", "grid.notBlank"],
  ["applyFilter", "grid.applyFilter"],
  ["resetFilter", "grid.resetFilter"],
  ["clearFilter", "grid.clearFilter"],
  ["sortAscending", "grid.sortAscending"],
  ["sortDescending", "grid.sortDescending"],
  ["sortUnSort", "grid.sortUnSort"],
] as const;

/**
 * Built-in AG Grid menu, filter, and empty-state text for the active locale.
 * Column titles stay in the screen catalogs; this covers only AG Grid's own copy.
 */
export function useGridLocaleText(): Record<string, string> {
  const t = useTimePilotT();
  return useMemo(() => {
    const localeText: Record<string, string> = {};
    for (const [agKey, catalogKey] of GRID_LOCALE_KEYS) {
      localeText[agKey] = t(catalogKey);
    }
    return localeText;
  }, [t]);
}
